import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNameFactory } from "@src/utils/dom";
import "./index.scss";
const cn = classNameFactory("checkmark");
export const AnimatableCheckMark = () => {
    return (_jsxs("svg", { className: cn(""), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 52 52", children: [_jsx("circle", { className: cn("circle"), cx: "26", cy: "26", r: "25", fill: "none" }), " ", _jsx("path", { className: cn("check"), fill: "none", d: "M14.1 27.2l7.1 7.2 16.7-16.8" })] }));
};
